import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { logout, switchAccount } from "../login/loginSlice";

export interface EmailState {
    activeFolder: string | null;
    activeEmail: string | null;
    emailsWritten: any[] | null;
    activeComposingEmail: string | null;
    folderRefreshNonce: number;
}

const initialState: EmailState = {
    activeFolder: null,
    activeEmail: null,
    emailsWritten: null,
    activeComposingEmail: null,
    folderRefreshNonce: 0
};

export const emailSlice = createSlice({
    name: 'emails',
    initialState,
    reducers: {
        changeFolder: (state, payload) => {
            state.activeFolder = payload.payload.folder;
            state.activeEmail = null;
        },
        loadEmail: (state, payload) => {
            state.activeEmail = payload.payload;
        },
        composeEmail: (state, payload) => {
            const { guid, to = "", cc = "", subject = "", body = "", header = "New Email", draftKey } = payload.payload;
            const newEmail = { guid, to, cc, from: "", subject, body, header, draftKey };
            if (state.emailsWritten) {
                state.emailsWritten?.push(newEmail);
            } else {
                state.emailsWritten = [newEmail]
            }
            state.activeComposingEmail = guid;
        },
        closeEmail: (state, payload) => {
            state.emailsWritten = state.emailsWritten!.filter((email) => {
                return email.guid !== payload.payload;
            });
            state.activeComposingEmail = null;
        },
        activeComposingEmail: (state, payload) => {
            state.activeComposingEmail = payload.payload;
        },
        refreshFolder: (state) => {
            state.folderRefreshNonce += 1;
        }
    },
    extraReducers: (builder) => {
        // The currently selected message belongs to whichever account was active when it was
        // clicked - clear it when the active account changes so PreviewPane doesn't try to fetch
        // that id under a different account's token.
        builder.addCase(switchAccount, (state) => {
            state.activeEmail = null;
        });
        builder.addCase(logout, (state) => {
            state.activeEmail = null;
        });
    }
});

export const { changeFolder, loadEmail, composeEmail, closeEmail, activeComposingEmail, refreshFolder } = emailSlice.actions;

export const activeFolder = (state: RootState) => state.emails.activeFolder || "inbox";

export const activeEmail = (state: RootState) => state.emails.activeEmail;

export const emailsBeingWritten = (state: RootState) => state.emails.emailsWritten;

export const currentComposingEmail = (state: RootState) => state.emails.activeComposingEmail;

export const folderRefreshNonce = (state: RootState) => state.emails.folderRefreshNonce;

export default emailSlice.reducer;